module.exports = __webpack_public_path__ + "static/media/team-member-1.892e3996.jpg";